import { Request } from 'fetchboi'

export const getCompanies = Request.register({
    endpoint: '/companies',
    method: 'get',
    useAuthentication: true
})

export const getCompanyByUser = Request.register({
    endpoint: '/users/:userId/companies',
    method: 'get',
    useAuthentication: true
})

export const getApprovedByCompanies = Request.register({
    endpoint: '/companies/:companyId/metrics',
    method: 'get',
    useAuthentication: true
})



// WEBPACK FOOTER //
// ./src/requests/companies.js